import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { programFullQuery } from '../api/queries/program';

import type { ProgramFull } from '@mio/shared';

/** The cached whole program. `select` keeps re-renders scoped to what a view needs. */
export function useProgramFull<T = ProgramFull>(
  select?: (program: ProgramFull) => T,
): UseQueryResult<T> {
  return useQuery({
    ...programFullQuery,
    select: select ?? ((program) => program as unknown as T),
  });
}
